import CTAButton from "./CTAButton";

function PDFButton() {
   return (
      <CTAButton
         modifier="secondary"
         htmlTag="button"
         openURL="pdf/Avado-Life.pdf"
         target="_blank"
      >
         PDF Version
      </CTAButton>
   );
}

export default PDFButton;
